module.exports = __webpack_public_path__ + "static/media/D-DIN.eb09665e.ttf";


//////////////////
// WEBPACK FOOTER
// ./font/d-din/D-DIN.ttf
// module id = 195
// module chunks = 0